export default "__VITE_ASSET__Cpx2UKLK__"